import * as React from "react";
import { SvgIcon } from "./SvgIcon";
import { LockSolid, UnlockAltSolid } from "@icons";
import * as cn from "classnames";

import "./PremiumFeatureIcon.css";

function chooseSvg(status: "trial" | "lock") {
    switch (status) {
        case "lock":
            return <SvgIcon svg={LockSolid} className="premium-feature__icon" />;
        case "trial":
            return <SvgIcon svg={UnlockAltSolid} className="premium-feature__icon" />;
        default:
            return null;
    }
}

function chooseHint(status: "trial" | "lock") {
    switch (status) {
        case "lock":
            return <div className="premium-feature__hint">Please contact Customer Support for this feature</div>;
        case "trial":
            return (
                <div className="premium-feature__hint">
                    Use of this premium feature is free of charge during the trial period
                </div>
            );
        default:
            return null;
    }
}

export interface PremiumFeatureIconProps {
    status: "trial" | "lock";
    className?: string;
}

export const PremiumFeatureIcon = (props: PremiumFeatureIconProps) => (
    <div className={cn("premium-feature__wrapper", props.className)}>
        <span className="premium-feature__icon-wrapper">{chooseSvg(props.status)}</span>
        {chooseHint(props.status)}
    </div>
);
